import { ProjectOutputFilterParams, defaultPlanOutputFilterValues } from "@/settings/projectOutputFilters";
import { ContentWidget, Layout } from "@/types/layouts";
import { Project } from "@/types/project";

export interface FilterParams {
  agency: string[] | null;
  advertiser: string[] | null;
  businessGoal: string[] | null;
  campaign: string[] | null;
  campaignKpi: string[] | null;
  campaignId: string[] | null;
  campaignBudget: string[] | null;
  channel: string[] | null;
  data_type?: string[] | null;
  industry: string[] | null;
  mediaType: string[] | null;
  page?: number;
  page_size?: number;
}

export type FilterState = {
  filterParams: FilterParams;
  selectedFilters: string[];
};

export interface Dashboard {
  id: string;
  title: string;
  icon: string;
  layout: Layout;
  filterState: FilterState;
  isDefaultPage?: boolean;
  idTemplate?: string;
}

export interface ProjectOutputDashboard {
  id: string;
  title: string;
  icon: string;
  layout: Layout;
  filterState: FilterState;
  isDefaultPage?: boolean;
  projectId?: string;
}

export interface UserSettings {
  modifiedAt?: number;
  dashboards: Dashboard[];
  projectOutputs?: ProjectOutputDashboard[];
}

export interface StateUserSettings {
  userSettings: UserSettings;
  filterState: FilterState;
  newPageFilterParams: FilterParams;
  isLoadingUserSettings: boolean;
  settingsFetchError: boolean;
  project: Project | null;
  projectLayout: Layout | null;
  projectFiltered: Project | null;
  isLoading: boolean;
  filters: ProjectOutputFilterParams;
  activeWidget: ContentWidget;
  showDrawerConfig: boolean;
}

export default {
  namespaced: true,

  state: {
    userSettings: {
      dashboards: [],
      projectOutputs: [],
    },
    filterState: {
      filterParams: {},
      selectedFilters: [],
    },
    newPageFilterParams: {
      dashboards: [],
    },
    isLoadingUserSettings: false,
    settingsFetchError: false,
    project: null,
    projectFiltered: null,
    isLoading: false,
    filters: { ...defaultPlanOutputFilterValues },
    activeWidget: {} as ContentWidget,
    showDrawerConfig: false,
  },

  mutations: {
    updateSelectWidget(state: StateUserSettings, item: ContentWidget): void {
      state.activeWidget = item;
    },

    updateShowDrawerConfig(state: StateUserSettings, value: boolean): void {
      state.showDrawerConfig = value;
    },

    updateLoadingUserSettings(state: StateUserSettings, value: boolean): void {
      state.isLoadingUserSettings = value;
    },

    updateFilterParams(state: StateUserSettings, value: FilterParams): void {
      state.filterState.filterParams = value;
    },
  },

  getters: {
    userSettings(state: StateUserSettings): UserSettings | null {
      return state.userSettings;
    },

    dashboards(state: StateUserSettings): Dashboard[] {
      return state.userSettings?.dashboards || [];
    },

    projectOutputs(state: StateUserSettings): Dashboard[] {
      return state.userSettings?.projectOutputs || [];
    },

    filterParams(state: StateUserSettings): FilterParams | null {
      return state?.filterState?.filterParams;
    },

    filterState(state: StateUserSettings): FilterState | null {
      return state?.filterState;
    },

    newPageFilterParams(state: StateUserSettings): FilterParams {
      return state.newPageFilterParams;
    },

    isLoadingUserSettings(state: StateUserSettings): boolean {
      return state.isLoadingUserSettings;
    },

    settingsFetchError(state: StateUserSettings): boolean {
      return state.settingsFetchError;
    },

    project(state: StateUserSettings) {
      return state.project;
    },
    projectLayout(state: StateUserSettings) {
      return state.project;
    },
    projectFiltered(state: StateUserSettings) {
      return state.projectFiltered;
    },
    isLoading(state: StateUserSettings) {
      return state.isLoading;
    },
    filters(state: StateUserSettings) {
      return state.filters;
    },
    isShowDrawerConfig: (state: StateUserSettings): boolean => {
      return state.showDrawerConfig;
    },
    activeWidget: (state: StateUserSettings): ContentWidget => {
      return state.activeWidget;
    },
  },
};
